import { Backdrop, Chip, CircularProgress, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import { LoaderComponentProps } from 'src/core/hooks/loader';

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            zIndex: theme.zIndex.drawer + 1,
            color: theme.palette.common.white,
        },
        stack: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        label: {
            marginTop: theme.spacing(2),
        },
    })
);

const BackdropLoader: React.FC<LoaderComponentProps> = ({ loading, label }) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.root} open={loading}>
            <div className={classes.stack}>
                <CircularProgress color="inherit" />
                {label && <Chip label={label} className={classes.label} />}
            </div>
        </Backdrop>
    );
};

export default BackdropLoader;
